import React, { useState, memo, useEffect, useMemo, useCallback } from 'react'
import moment from 'moment'
import { withStyles } from '@material-ui/core/styles'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'

import style from './style'

function DateSessionFilter({ classes, items, onChange }) {
  const [date, setDate] = useState('all')
  const [session, setSession] = useState('all')
  const [dateItems, setDateItems] = useState([])
  const [sessionItems, setSessionItems] = useState([])

  const updatesItems = useMemo(
    () =>
      items.map(item => {
        const dateTime = moment(item.dateTime).format('D-MMM-YYYY HH:mm')

        return {
          ...item,
          dateTime,
        }
      }),
    [items],
  )

  useEffect(() => {
    const sessionItems = []
    const dateItems = []

    updatesItems.forEach(item => {
      const [dateItem, sessionItem] = item.dateTime.split(' ')

      if (date !== 'all') {
        dateItems.push(dateItem)

        if (dateItem === date) {
          sessionItems.push(sessionItem)
        }
      }

      if (session !== 'all' && sessionItem === session) {
        sessionItems.push(sessionItem)
      }

      if (date === 'all' && session === 'all') {
        dateItems.push(dateItem)
        sessionItems.push(sessionItem)
      }
    })

    setDateItems([...new Set(dateItems)])
    setSessionItems([...new Set(sessionItems)])
  }, [updatesItems, date, session])

  useEffect(() => {
    if (date === 'all' && session === 'all') {
      onChange(items)
    } else {
      const filteredItems = updatesItems.filter(item => {
        if (date === 'all' && session !== 'all') {
          return item.dateTime.includes(session)
        }
        if (date !== 'all' && session === 'all') {
          return item.dateTime.includes(date)
        }
        if (date !== 'all' && session !== 'all') {
          return item.dateTime.includes(session) && item.dateTime.includes(date)
        }

        return false
      })
      onChange(filteredItems)
    }
  }, [session, date, onChange, updatesItems])

  const handleDateChange = useCallback(e => {
    setDate(e.target.value)
    setSession('all')
  }, [])

  const handleSessionChange = useCallback(e => {
    setSession(e.target.value)
  }, [])

  return (
    <div className={classes.filter}>
      <FormControl variant="outlined">
        <InputLabel>Date</InputLabel>
        <Select value={date} onChange={handleDateChange}>
          {dateItems.map(item => (
            <MenuItem value={item}>{item}</MenuItem>
          ))}
          <MenuItem value="all">All</MenuItem>
        </Select>
      </FormControl>
      <FormControl variant="outlined">
        <InputLabel>Session</InputLabel>
        <Select
          disabled={date === 'all'}
          value={session}
          onChange={handleSessionChange}
        >
          {sessionItems.map(item => (
            <MenuItem value={item}>{item}</MenuItem>
          ))}
          <MenuItem value="all">All</MenuItem>
        </Select>
      </FormControl>
    </div>
  )
}

export default memo(withStyles(style)(DateSessionFilter))



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Ambasadors/AmbassadorsPipelineView/components/PipelineColumn/ColumnHeader/DateSessionFilter/index.js